import React from 'react';

export function Logo({ width, height }: { width?: number; height?: number }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 94 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9072 0V11.0225L17.1396 0H23.373L18.6982 15.7764H14.0635L26.5293 22.0879L20.2568 31.6338L10.9072 20.5381V28.3984H0L3.73926 15.7764H0L4.6748 0H10.9072Z"
        fill="#F4FF00"
      />
      <path
        d="M86.8636 23.75C84.1498 23.75 82.6735 22.3171 82.6735 19.8638V19.3645H84.215V19.6467C84.215 21.0796 85.1485 21.9263 86.7117 21.9263H88.9261C90.3807 21.9263 91.2275 21.1447 91.2275 19.777V19.1908C91.2275 17.7796 90.3807 16.9546 88.9261 16.9546H86.4294C84.063 16.9546 82.6735 15.5434 82.6735 13.1335V12.721C82.6735 10.3112 84.063 8.89999 86.4294 8.89999H88.9479C91.3577 8.89999 92.7255 10.246 92.7255 12.5474V13.0467H91.184V12.7428C91.184 11.4618 90.3807 10.702 89.013 10.702H86.4511C84.9965 10.702 84.215 11.4401 84.215 12.8079V13.0901C84.215 14.4796 84.9965 15.2395 86.4511 15.2395H88.8393C91.3577 15.2395 92.7906 16.6941 92.7906 19.1474V19.8638C92.7906 22.3171 91.336 23.75 88.861 23.75H86.8636Z"
        fill="#F4FF00"
      />
      <path
        d="M70.6789 23.7066V8.94342H76.5841C79.2545 8.94342 80.7309 10.55 80.7309 13.0684V14.6099C80.7309 17.0414 79.1894 18.6697 76.5841 18.6697H72.2855V23.7066H70.6789ZM72.2855 16.8895H76.4105C78.1256 16.8895 79.1243 16.0211 79.1243 14.523V13.1336C79.1243 11.6355 78.1256 10.7671 76.4105 10.7671H72.2855V16.8895Z"
        fill="#F4FF00"
      />
      <path
        d="M58.3183 23.7066V8.94342H64.6361C66.8939 8.94342 68.24 10.2243 68.24 12.3954V14.675C68.24 16.3033 67.3282 17.4539 65.8301 17.8013L68.7176 23.7066H67.0025L64.2236 18.0618H59.9249V23.7066H58.3183ZM59.9249 16.3033H64.6361C65.9387 16.3033 66.6551 15.6086 66.6551 14.3059V12.8513C66.6551 11.5053 65.8953 10.7671 64.5058 10.7671H59.9249V16.3033Z"
        fill="#F4FF00"
      />
      <path
        d="M46.2334 23.7066V8.94342H55.8077V10.8105H47.84V15.1961H55.8077V17.0849H47.84V21.8395H55.8077V23.7066H46.2334Z"
        fill="#F4FF00"
      />
      <path
        d="M34 23.7064V8.94327H39.9053C42.5756 8.94327 44.052 10.5498 44.052 13.0683V14.6097C44.052 17.0413 42.5105 18.6696 39.9053 18.6696H35.6066V23.7064H34ZM35.6066 16.8893H39.7316C41.4467 16.8893 42.4454 16.0209 42.4454 14.5229V13.1334C42.4454 11.6354 41.4467 10.767 39.7316 10.767H35.6066V16.8893Z"
        fill="#F4FF00"
      />
    </svg>
    // KUMA
    // <svg
    //   width={width || 47}
    //   height={height} /* 12px default (based on viewBox) */
    //   // width="47"
    //   // height="12"
    //   viewBox="0 0 47 12"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M27.7976 6.29848C27.7159 5.04838 26.823 4.29876 25.6167 4.29876C24.4233 4.29876 23.4583 5.05511 23.3776 6.29848H21.6455V2.8776H23.3721V3.93386C24.0052 3.14646 24.9836 2.68555 26.1155 2.68555C27.42 2.68555 28.5135 3.3001 29.1082 4.33717C29.7413 3.3001 30.8924 2.68555 32.1969 2.68555C34.1538 2.68555 35.7077 4.01068 35.7077 6.14243V6.29848H33.9558C33.8742 5.04838 32.9821 4.29876 31.7941 4.29876C30.5823 4.29876 29.6166 5.05511 29.5358 6.29848H27.7976Z"
    //     fill="white"
    //   />
    //   <path
    //     d="M0 0H2.15338V8.05968L1.04836 9.42936H2.15338L7.53142 2.76329H9.57689L5.80659 7.43654L9.86023 11.9932H7.70685L4.80195 8.68181L2.15338 11.9647H0V0Z"
    //     fill="white"
    //   />
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M37.2794 7.29724C37.2794 9.9399 39.1977 11.9932 41.6858 11.9932C42.9773 11.9932 44.041 11.4609 44.6867 10.5863V11.8031H46.4151V2.77239H44.6867V4.00817C44.041 3.11461 42.9584 2.58227 41.6858 2.58227C39.1977 2.58227 37.2794 4.65458 37.2794 7.29724ZM44.8007 7.29724C44.8007 9.12239 43.6611 10.3772 41.9707 10.3772C40.2613 10.3772 39.0458 9.08436 39.0458 7.27823C39.0458 5.47209 40.2423 4.19829 41.9517 4.19829C43.6611 4.19829 44.8007 5.45308 44.8007 7.29724Z"
    //     fill="white"
    //   />
    //   <path
    //     d="M11.58 8.01974C11.58 10.3582 13.1755 11.9932 15.4546 11.9932C17.7338 11.9932 19.3102 10.3772 19.3102 8.01974V2.77244H17.6009V7.94369C17.6009 9.44564 16.8031 10.3392 15.4546 10.3392C14.1061 10.3392 13.2894 9.42663 13.2894 7.94369V2.77244H11.58V8.01974Z"
    //     fill="white"
    //   />
    //   <path
    //     d="M23.3769 6.29834H25.1755L23.4519 11.9998H21.6533L23.3769 6.29834Z"
    //     fill="#EE3F3F"
    //   />
    //   <path
    //     d="M29.5083 6.29834H31.3068L29.5832 11.9998H27.7847L29.5083 6.29834Z"
    //     fill="#EE3F3F"
    //   />
    //   <path
    //     d="M35.6396 6.29834H37.4382L35.7146 11.9998H33.916L35.6396 6.29834Z"
    //     fill="#EE3F3F"
    //   />
    // </svg>
    // PREVIOUS
    // <svg
    //   width={width || 65}
    //   height={height} /* 16px default (based on viewBox) */
    //   // preserveAspectRatio="xMidYMid meet"
    //   viewBox="0 0 65 16"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   // Align it as proper element (removes bottom padding while using flex)
    //   style={{ display: 'block' }}
    // >
    //   <path
    //     d="M21.0355 2.29376H24.6157V13.7063H21.0355V2.29376Z"
    //     fill="white"
    //   />
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M43.22 2.29376H40.2251V11.3038C40.2251 12.6311 41.2975 13.7068 42.6209 13.7068H50.4068V10.7036H43.8185V9.50215H48.1627V6.49897H43.8185V5.29749H50.4068V2.29376H43.2194H43.22Z"
    //     fill="white"
    //   />
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M29.9291 2.29376H27.0219V13.7063H32.6145C35.7661 13.7063 38.3208 11.1516 38.3208 8.00001C38.3208 4.84844 35.7661 2.29376 32.6145 2.29376H29.9291ZM30.6027 5.37085V10.6297H32.6145C34.0665 10.6297 35.2437 9.4525 35.2437 8.00001C35.2437 6.54752 34.0665 5.37085 32.6145 5.37085H30.6027Z"
    //     fill="white"
    //   />
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M0 13.7145L0.278031 14.0714L1.77796 16H14.2226L16.0006 13.7145L11.5559 8L15.7225 2.64295L16.0006 2.28603L14.2226 0H1.77796L1.49441 0.364088L0 2.28548L4.44463 8L0 13.7145ZM5.35981 12.5715C4.98745 12.5715 4.77782 12.1434 5.00676 11.8494L6.22259 10.286L8.00055 12.5715H5.35981ZM11.2729 7.63591L15.1565 2.64295H7.96083C7.72804 2.64295 7.5973 2.9105 7.74017 3.09419L8 3.42849H10.6407C11.0131 3.42849 11.2227 3.85712 10.9938 4.1506L9.77796 5.71397L11.2724 7.63536L11.2729 7.63591ZM0.566543 2.28548L9.31954 13.5396L9.38243 13.6202C9.52531 13.8039 9.39457 14.0714 9.16177 14.0714H0.844573L2.06703 15.6431H13.378L1.77796 0.728727L0.566543 2.28548Z"
    //     fill="white"
    //   />
    //   <path
    //     d="M64.4479 2.30811H60.556L58.9176 4.53566L60.8638 7.18136L64.4479 2.30811Z"
    //     fill="white"
    //   />
    //   <path
    //     d="M58.3103 5.36148L56.0645 2.30811H52.1726L56.3641 8.00718L52.1726 13.7063H56.0645L58.3103 10.6534L60.2565 8.00773V8.00718L58.3103 5.36148Z"
    //     fill="white"
    //   />
    //   <path
    //     d="M58.9176 11.4798L60.556 13.7063H64.4479L60.8638 8.83356L58.9176 11.4798Z"
    //     fill="white"
    //   />
    // </svg>
  );
}
